<template>
  <Form ref="attendanceUserForm" :model="attendanceUser" v-loading="loading" :disabled="actionType=='detail'" :rules="ruleValidate" :label-width="100" >
     <input v-model="attendanceUser.id" type="hidden"/>
    <FormItem  :label="this.$t('ipms.attendance-user.userName.label')" prop="userName">
      <Input v-model="attendanceUser.userName" :placeholder="$t('ipms.attendance-user.userName.holder')"/>
    </FormItem>
    <FormItem  :label="this.$t('ipms.attendance-user.userPost.label')" prop="status">
      <Select v-model="attendanceUser.userPost" :placeholder="$t('ipms.attendance-user.userPost.holder')">
        <Option v-for="item in dict.userPost" :value="item.dictKey" :key="item.dictValue">{{item.dictValue }}</Option>
      </Select>
    </FormItem>
    <FormItem  :label="this.$t('ipms.attendance-user.userCategory.label')" prop="status">
      <Select v-model="attendanceUser.userCategory" :placeholder="$t('ipms.attendance-user.userCategory.holder')">
        <Option v-for="item in dict.userCategory" :value="item.dictKey" :key="item.dictValue">{{item.dictValue }}</Option>
      </Select>
    </FormItem>
    <FormItem  :label="this.$t('ipms.attendance-user.attendanceGroup.label')" prop="status">
      <Select v-model="attendanceUser.attendanceGroup" :placeholder="$t('ipms.attendance-user.attendanceGroup.holder')">
        <Option v-for="item in dict.attendanceGroup" :value="item.dictKey" :key="item.dictValue">{{item.dictValue }}</Option>
      </Select>
    </FormItem>

    <FormItem  :label="this.$t('ipms.attendance-user.remark.label')" prop="remark">
      <Input v-model="attendanceUser.remark" :placeholder="$t('ipms.attendance-user.remark.holder')"  type="textarea" :rows="3"/>
    </FormItem>

    <FormItem  :label="this.$t('ipms.attendance-user.status.label')" prop="status">
      <Select v-model="attendanceUser.status" :placeholder="$t('ipms.attendance-user.status.holder')">
        <Option v-for="item in dict.status" :value="item.dictKey" :key="item.dictValue">{{item.dictValue }}</Option>
      </Select>
    </FormItem>

  </Form>
</template>
<script>
import dict from '@/components/dict'
import api from '@/api'

export default {
  dictParams: ['userPost','userCategory','attendanceGroup','status'],
    components: {
      'dict-tag': dict
    },
  data () {
    return {
      attendanceUser: {
        id: null,
        userName: null,
        userPost: 0,
        userCategory: 0,
        attendanceGroup: 0,
        remark: null,
        status: 1,
        createTime: null,
        updateTime: null,
        deleted: 0
      },
      loading: false,
      actionType:'add'
    }
  },
  methods: {
    handleSubmit(then,error){
      this.$refs['attendanceUserForm'].validate(valid => {
        if (valid) {
          if (this.attendanceUser.id) {
            this.updateAttendanceUser(this.attendanceUser).then(then).error(error)
          } else {
            this.createAttendanceUser(this.attendanceUser).then(then).error(error)
          }
        } else {
          this.$Message.error(this.$t('errorText'))
          error()
        }
      })
    },
    handleReset(){
      this.attendanceUser.id = ''
      this.actionType = 'add';
      this.$nextTick(()=>this.$refs['attendanceUserForm'].resetFields());
    },
    getAttendanceUser(id,type){
      this.loading = true;
      this.$refs['attendanceUserForm'].resetFields()
      api.ipms.AttendanceUser.detail(id).then(data => {
        this.attendanceUser = data;
        this.loading = false;
        this.actionType = type;
      }).catch(e => this.loading = false)
    },
    createAttendanceUser(attendanceUser){
      this.loading = true;
      return api.ipms.AttendanceUser.add(attendanceUser)
          .then(response => {
            this.loading = false;
            if(response.code==400){
              this.$Message.error(response.message)
            }else{
              this.$Message.success(response.message)
            }
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    },
    updateAttendanceUser(attendanceUser){
      this.loading = true;
      return api.ipms.AttendanceUser.update(attendanceUser)
          .then(response => {
            this.loading = false;
            if(response.code==400){
              this.$Message.error(response.message)
            }else{
              this.$Message.success(response.message)
            }
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    }
  },
  computed: {
    ruleValidate(){
      let validate =  {
      userName: [{type: 'string', required: true, message: this.$t('ipms.attendance-user.userName.required'),trigger: 'blur'}, {type: 'string',max: 50, message: this.$t('ipms.attendance-user.userName.max'),trigger: 'blur'}],
      userPost: [{type: 'number', required: true, message: this.$t('ipms.attendance-user.userPost.required'),trigger: 'blur'}],
      userCategory: [{type: 'number', required: true, message: this.$t('ipms.attendance-user.userCategory.required'),trigger: 'blur'}],
      attendanceGroup: [{type: 'number', required: true, message: this.$t('ipms.attendance-user.attendanceGroup.required'),trigger: 'blur'}],
      remark: [{type: 'string',max: 500, message: this.$t('ipms.attendance-user.remark.max'),trigger: 'blur'}],
      status: [{type: 'number', required: true, message: this.$t('ipms.attendance-user.status.required'),trigger: 'blur'}]
      }
      if(this.actionType == 'edit'){
        this.$refs['attendanceUserForm'].fields.forEach(f => {
          if(f.$children[0].disabled){
            delete validate[f.prop]
          }
        })
      }else if(this.actionType == 'detail'){
        return {}
      }
      return validate;
    }
  }
}
</script>
